import { render, staticRenderFns } from "./NoticeIntentionProceed.vue?vue&type=template&id=c52939a2"
import script from "./NoticeIntentionProceed.vue?vue&type=script&lang=ts"
export * from "./NoticeIntentionProceed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports